exports.f = require('./_wks');



/*****************
 ** WEBPACK FOOTER
 ** /Users/endriu/Work/adoratorio/temp/ahs-site/ahs/~/core-js/modules/_wks-ext.js
 ** module id = 28
 ** module chunks = 0
 **/